<template>
<div>
    
    <router-link to='/' class="absolute -top-2 left-4 block md:hidden">
        <img src="@/assets/images/v2/Icon awesome-arrow-left.png" alt="" class="mx-auto mt-16">
    </router-link>

    <img src="@/assets/images/v2/Grupo 23.png" style="width: 180px" alt="" class="mx-auto mt-10">

    <div class="container">
        <div class="row items-center">
            <div class="col-md-6">
                <video loop="true" muted autoplay playsinline class="w-100">
                    <source src="@/assets/primer_escudo_v2.mp4" type="video/mp4">
                    <source src="movie.ogg" type="video/ogg">
                    Your browser does not support the video tag.
                </video>
            </div>
            <div class="col-md-6">
                <h3 class="pre-title title-border-left">L’ORIGEN DE L’ESCUT</h3>
                <p>L’escut original del Girona FC data de l’1 d’Agost de 1930, el dia en que l’Ajuntament de Girona va permetre al Girona Futbol Club, que s’havia fundat pocs dies abans, fer servir l’emblema de la ciutat dins de l’escut del Club.</p>
                <p>És a les hores quan el Girona pren <span class="font-weight-bold">l’escut de la ciutat com a eix central</span> del seu escut original.</p>
                <p><i class="fas fa-check-circle" style="color: #CD1733; margin-right: 3px;"></i>L'emblema de la ciutat estava format per una senyera en forma de rombe; al centre, unes onades blanc-i-vermelles en forma d’escut; i a dalt, la corona ducal que utilitzava la ciutat al 1930.</p>
                <p><i class="fas fa-check-circle" style="color: #CD1733; margin-right: 3px;"></i> El Club va afegir una forma circular, amb llistes vermelles i blanques, en diagonal, que simbolitzen els colors que utilitzaria el Girona FC a la seva samarreta i una doble bordura circular on apareix el nom del club escrit en lletres negres sobre fons blanc.</p>
            </div>
        </div>
    </div>

    <div class="evolucio">
        <div class="container">
            <div class="text-center">
                <h3 class="pre-title">EVOLUCIÓ DE L’ESCUT</h3>
                <p class="text-max-800">L’escut original es va mantenir, pràcticament inalterat, des de l’any 1930 fins a inicis dels anys 2000. Al 2005, amb motiu del 75è aniversari, el Club va realitzar canvis substancials en el disseny, molts dels quals s’apliquen a l’escut actual. Els canvis més significatius al llarg dels anys són els següents:</p>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <div id="evolucio-slider">
                        <div class="item">
                            <img src="@/assets/img/ESCUT_1930.jpg" style="width:100%;height:100%;" alt="">
                            <div class="title">1930 - FUNDACIONAL</div>
                            <p class="desc">L'escut del Club es forma amb la base de l'escut de la ciutat on s'afegeix una bordura blanca amb llistes blanc-i-vermelles que representen els colors que vestiria l'equip. </p>
                        </div>
                        <div class="item">
                            <img src="@/assets/img/ESCUT_1940.jpg" style="width:100%;height:100%;" alt="">
                            <div class="title">1940</div>
                            <p class="desc">A partir de la dictadura franquista, i com a conseqüència de la reglamentació que prohibeix els noms en català o d’origen estranger, es castellanitza el nom del club a “GERONA CLUB de FUTBOL”.</p>
                        </div>
                        <div class="item">
                            <img src="@/assets/img/ESCUT_1970.jpg" style="width:100%;height:100%;" alt="">
                            <div class="title">1970</div>
                            <p class="desc">En anys posteriors, una petita variació sobre la corona, que deixa de banda l’ombrejat negre que li donava volum i passa a ser, aquest ombrejat, de color groc. Es redueix el tamany de la lletra del nom del club.</p>
                        </div>
                        <div class="item">
                            <img src="@/assets/img/ESCUT_1980.jpg" style="width:100%;height:100%;" alt="">
                            <div class="title">1980</div>
                            <p class="desc">Ja en democràcia, als anys 80, torna la nomenclatura original i es recupera l’ombrejat negre de la corona, la qual, amb petits canvis, es manté igual.</p>
                        </div>
                        <div class="item">
                            <img src="@/assets/img/ESCUT_2008.jpg" style="width:100%;height:100%;" alt="">
                            <div class="title">2005</div>
                            <p class="desc">El canvi més destacat en els 90 anys d’història. La bordura passa a ser vermella i el perfilat més gruixut. La corona es simplifica i es separa de l’escut de la ciutat, passant a timbrar l’escut del club. S’inclina i disminueix el nombre de llistes blanc-i-vermelles alhora que es redueix el nom del club, un 50% més petit respecte l’escut original.</p>
                        </div>
                        <div class="item">
                            <img src="@/assets/img/ESCUT_2012.jpg" style="width:100%;height:100%;" alt="">
                            <div class="title">2012</div>
                            <p class="desc">El color de les aigües torna a ser vermell i blanc.</p>
                        </div>
                        <div class="item">
                            <img src="@/assets/img/ESCUT_ACTUAL_v2.png" style="width:100%;height:100%;" alt="">
                            <div class="title">2015 - Actual</div>
                            <p class="desc">El color de la corona passa a ser daurat i s’estilitza el nom del club.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="elements">
        <div class="container">
            <div class="text-center">
                <h3 class="pre-title">ELS ELEMENTS DE L’ESCUT ACTUAL</h3>
                <p class="text-max-800">Descobreix el significat dels elements que formen l’escut del Girona FC fent clic sobre cada element.</p>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <elements-component></elements-component>
                </div>
            </div>
        </div>
    </div>

    <div class="container">
        <div class="row">
            <div class="col-md-4 offset-md-4 text-center">
                <router-link to="/" class="btn btn-danger btn-block bg-girona mt-6 uppercase font-normal text-xl rounded-lg mb-12">
                    Tornar enrere
                </router-link>
            </div>
        </div>
    </div>

    <div class="partners bg-girona mt-12">
        <div class="container">
            <div class="row">
                <div class="col-md-12 my-3 d-flex justify-content-center align-items-center">
                    <div class="mt-3 mr-5 text-center">
                        <a href="https://gosbi.com/" target="_blank">
                            <img src="@/assets/img/partners/gosbi_white.png" class="img-fluid" style="width: 150px;" alt="">
                        </a>
                    </div>
                    
                    <div class="mt-3 mr-5 text-center">
                        <a href="https://eu.puma.com/es/es/home" target="_blank">
                            <img src="@/assets/img/partners/Logo_Puma.png" class="img-fluid" style="width: 100px;" alt="">
                        </a>
                    </div>
                    <div class="mt-3 mr-5 text-center">
                        <a href="https://es.costabrava.org/" target="_blank">
                            <img src="@/assets/img/partners/Logo_CostaBrava.png" class="img-fluid" style="width: 150px;" alt="">
                        </a>
                    </div>
                    <!-- <div class="mt-3 text-center">
                        <a href="https://www.factorenergia.com/es/" target="_blank">
                            <img src="@/assets/img/partners/Logo_Factorenergia.png" class="img-fluid" style="width: 150px;" alt="">
                        </a>
                    </div> -->
                </div>
                <div class="col-md-12 d-flex justify-content-center align-items-center">
                    <div class="mt-3 mr-5 text-center">
                        <a href="https://www.estrelladamm.com/es/" target="_blank">
                            <img src="@/assets/img/partners/Logo_EstrellaDamm.png" class="img-fluid" style="width: 120px;" alt="">
                        </a>
                    </div>
                    <div class="mt-3 mr-5 text-center">
                        <a href="https://www.caixabank.es/particular/home/particulares_es.html" target="_blank">
                            <img src="@/assets/img/partners/Logo_Caixabank.png" class="img-fluid" style="width: 150px;" alt="">
                        </a>
                    </div>
                    <div class="mt-3 text-center">
                        <a href="https://www.nissan.es/" target="_blank">
                            <img src="@/assets/img/partners/Logo_Nissan.png" class="img-fluid" style="width: 120px;" alt="">
                        </a>
                    </div>
                    <div class="mt-3 ml-5 text-center">
                        <a href="https://www.medplaya.es/" target="_blank">
                            <img src="@/assets/img/partners/Logo_MedPlaya.png" class="img-fluid" style="width: 150px;" alt="">
                        </a>
                    </div>
                </div>
                <div class="col-md-12 my-3 d-flex justify-content-center align-items-center">
                    <!-- <div class="mt-3 mr-5 text-center">
                        <a href="https://leoboeck.com/" target="_blank">
                            <img src="@/assets/img/partners/Logo_LeoBoek.png" class="img-fluid" style="width: 170px;" alt="">
                        </a>
                    </div> -->
                    <div class="mt-3 mr-5 text-center">
                        <a href="https://www.viajeselcorteingles.es/" target="_blank">
                            <img src="@/assets/img/partners/Logo_ECI.png" class="img-fluid" style="width: 150px;" alt="">
                        </a>
                    </div>
                    <!-- <div class="mt-3 mr-5 text-center">
                        <a href="https://www.besoccer.com/" target="_blank">
                            <img src="@/assets/img/partners/Logo_BeSoccer.png" class="img-fluid" style="width: 150px;" alt="">
                        </a>
                    </div> -->
                    <div class="mt-3 mr-5 text-center">
                        <a href="https://leoboeck.com" target="_blank">
                            <img src="@/assets/img/partners/LeoBoeck_Logo.png" class="img-fluid" style="width: 120px;" alt="">
                        </a>
                    </div>

                    <div class="mt-3 mr-5 text-center">
                        <a href="https://parlem.com/" target="_blank">
                            <img src="@/assets/img/partners/Logo_Parlem.png" class="img-fluid" style="width: 150px;" alt="">
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import ElementsComponent from './ElementsComponent'

require('@/assets/css/app.css')
require('../bootstrap');
var mobile = require('is-mobile');

export default {
    data() {
        return {
            isMobile: mobile(),
        }
    },
    components: {
        ElementsComponent,
    },
    mounted() {
        var instance = this
        window.Popper = require('popper.js').default;
        window.$ = window.jQuery = require('jquery');

        (function ($) {

            "use strict";

            $(document).ready(function () {

                setTimeout(() => {
                    $('#evolucio-slider').slick({
                        centerMode: true,
                        slidesToScroll: 1,
                        centerPadding: '20px',
                        slidesToShow: 3,
                        adaptiveHeight: false,
                        arrows: true,
                        autoplay: true,
                        cssEase: 'linear',
                        prevArrow: '<button class="slick-prev"> < </button>',
                        nextArrow: '<button class="slick-next"> > </button>',
                        responsive: [
                            {
                                breakpoint: 768,
                                settings: {
                                    arrows: false,
                                    centerMode: true,
                                    centerPadding: '90px',
                                    slidesToShow: 1
                                }
                            },
                        ]
                    });
                    $('#motius-slider').slick({
                        slidesToShow: 1,
                        autoplay: true,
                        dots: true,
                        arrows: false
                    });
                }, 200);


            });

        })(jQuery);
    },
    methods: {

    }
}
</script>
